'use client';

import RoadMapPanel from '../../../../features/graph/RoadMapPanel';
import MarkDownContainer from './MarkDownContainer';
import { User } from '@supabase/supabase-js';
import { getUser } from '../../../actions/getUser';
import { useSearchParams } from 'next/navigation';
import MobileSidebarContainer from '../../../../features/sidebar/MobileSidebarContainer';
import React, { useMemo } from 'react';
import DesktopSidebarContainer from '../../../../features/sidebar/DesktopSidebarContainer';
import LayoutFlowContainer from '@/features/graph/LayoutFlowContainer';
import { ReactFlowProvider } from '@xyflow/react';
import RoadMapPanelHeader from '@/features/graph/RoadMapPanelHeader';

const PanelSwitch = ({ user }: { user: User | null }) => {
  const showIntro = useSearchParams().get('showIntro');
  const showFlow = useSearchParams().get('flow');
  const [showLoadingContent, setShowLoadingContent] = React.useState(false);

  const DesktopFlow = useMemo(() => {
    return (
      <ReactFlowProvider>
        <LayoutFlowContainer graphID={'desktop-sidebar-graph'} />
      </ReactFlowProvider>
    );
  }, []);

  const TabletFlow = useMemo(() => {
    return (
      <ReactFlowProvider>
        <LayoutFlowContainer graphID={'tablet-sidebar-graph'} />
      </ReactFlowProvider>
    );
  }, []);

  const MobileFlow = useMemo(() => {
    return (
      <ReactFlowProvider>
        <LayoutFlowContainer graphID={'mobile-sidebar-graph'} isMobileSidebar={true} />
      </ReactFlowProvider>
    );
  }, []);

  return (
    <>
      <MobileSidebarContainer
        user={user}
        setShowLoadingContent={setShowLoadingContent}
        graphID={'mobile-panel-switch-graph'}
      >
        {MobileFlow}
      </MobileSidebarContainer>

      <div className="flex items-center justify-center max-h-screen overflow-hidden">
        {/* Mobile */}
        <div className="min-[1000px]:hidden w-[100%] min-w-[350px] min-[1000px]:max-w-[600px] shrink-0 bg-shades-base min-h-screen">
          {showIntro ? (
            <>
              <div className="min-[1000px]:hidden">
                <MarkDownContainer
                  isNavLoading={showLoadingContent}
                  isRoadMap={true}
                  setIsLoading={setShowLoadingContent}
                />
              </div>
            </>
          ) : (
            <div className="min-w-screen h-screen">
              <div className="min-w-screen h-screen">
                {/* <div className="pt-4 @mobile/sidebar:pt-2  pb-0.5 px-4 @mobile/sidebar:px-6">
                <RoadMapPanelHeader user={user} />
                </div> */}
                <div className="min-w-screen h-screen">{TabletFlow}</div>
              </div>
              <div className="absolute w-full px-4 top-3 right-0 z-[9999] visible">
                <RoadMapPanelHeader user={user} />
              </div>
            </div>
          )}
        </div>
        {/* Desktop */}
        <div className="flex-1 max-[1000px]:hidden">
          <ReactFlowProvider>
            <DesktopSidebarContainer
              user={user}
              setShowLoadingContent={setShowLoadingContent}
              showLoadingContent={showLoadingContent}
              graphID={'desktop-sidebar-graph'}
              flow={DesktopFlow}
            >
              <MarkDownContainer
                isNavLoading={showLoadingContent}
                isRoadMap={true}
                setIsLoading={setShowLoadingContent}
              />
            </DesktopSidebarContainer>
          </ReactFlowProvider>
        </div>
      </div>
    </>
  );
};

export default PanelSwitch;
